const rotuloRemessa = (remessa: string | number): string => {
  const texto = String(remessa).trim();
  const multipla = texto.includes(",");

  return multipla ? `Suas Remessas Nº ${texto}` : `Sua Remessa Nº ${texto}`;
};

// Mensagens padrão por tipo de entrega
const handleMensagensPorTipo: Record<
  string,
  (
    nome: string,
    remessa: string | number,
    endereco: string,
    responsavel: string,
    setor: string
  ) => string
> = {
  balcao: (nome, remessa) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} já está disponível para retirada no Balcão da Letscom.
Segue abaixo o endereço e horário de retirada:

Letscom
Rua Iguaçu, 674 – Casa 1
Bairro Concórdia

Horário de Retirada: 
Segunda a Sexta de 08h30 às 12h e 13h30 às 17h.

OBS: 
1. Não realizamos entrega de pedido na calçada.
2. O colaborador / motoboy deverá tocar o interfone (Casa 1) e informar a retirada do pedido da “EMPRESA SOLICITANTE”.
3. Não acompanhamos a rota via app de entrega (Ex: Uber entrega).`,

  correios: (nome, remessa, endereco, responsavel, setor) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} será enviada via Correios. Em breve você receberá o rastreio e o pedido no enderço:
${endereco}

Setor: ${setor} 
Responsável: ${responsavel}

Qualquer dúvida, entre em contato.`,

  motoboy_letscom: (nome, remessa, endereco, responsavel, setor) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} será entregue via Motoboy Letscom, em horário comercial, no endereço:
${endereco}

Setor: ${setor} 
Responsável: ${responsavel}

Por favor, certifique-se de que alguém estará disponível para receber.
Obs: As entregas são realizadas às quartas e sexta-feiras.`,

  outros: (nome, remessa) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} foi despachada e será entregue conforme combinado.`,
};

export { handleMensagensPorTipo };
